module.exports = __webpack_public_path__ + "static/brm-logo05-1-efd3c73a0396b91a8784f53ddf2e3468.svg";